import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  // eslint-disable-next-line no-console
  console.error(
    "Missing REACT_APP_CLERK_PUBLISHABLE_KEY. Set it in indexing-client/.env to enable authentication."
  );
}

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY ?? ""}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
